import api from './api';

export const getDocuments = async () =>
  api({
    url: '/uploads',
    method: 'get',
  });

export const uploadDocument = async ({ ...data }) =>
  api({
    url: '/upload-document',
    method: 'post',
    headers: {
      'content-type': 'multipart/form-data',
    },
    data,
  })

export const downloadDocument = async (id) =>
  api({
    url: `/uploads/${id}/download`,
    method: 'get',
  });
  